import React from "react"
import {Input, InputProps} from "@reverb-ui/react"

export type TCustomInputProps = InputProps & {
  isValid?: boolean
}

export const CustomInput = React.forwardRef(({ isValid, ...props }: TCustomInputProps, ref: any) => (
  <Input
    {...props}
    ref={ref}
    borderColor={isValid ? "green.300": undefined}
    borderWidth={isValid ? "2px" : undefined}
  />
))

CustomInput.displayName = "CustomInput"